var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseModalCreatePlan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.822 26.178C14.1345 26.4905 14.5584 26.666 15.0003 26.666C15.4422 26.666 15.8661 26.4905 16.1786 26.178L20.0003 22.3564L23.822 26.178C24.1363 26.4816 24.5573 26.6496 24.9943 26.6458C25.4313 26.642 25.8493 26.4667 26.1583 26.1577C26.4673 25.8487 26.6426 25.4307 26.6464 24.9937C26.6502 24.5567 26.4822 24.1357 26.1786 23.8214L22.357 19.9997L26.1786 16.178C26.4822 15.8637 26.6502 15.4427 26.6464 15.0057C26.6426 14.5687 26.4673 14.1507 26.1583 13.8417C25.8493 13.5327 25.4313 13.3574 24.9943 13.3536C24.5573 13.3498 24.1363 13.5178 23.822 13.8214L20.0003 17.643L16.1786 13.8214C15.8643 13.5178 15.4433 13.3498 15.0063 13.3536C14.5693 13.3574 14.1513 13.5327 13.8423 13.8417C13.5333 14.1507 13.358 14.5687 13.3542 15.0057C13.3504 15.4427 13.5184 15.8637 13.822 16.178L17.6436 19.9997L13.822 23.8214C13.5095 24.1339 13.334 24.5578 13.334 24.9997C13.334 25.4416 13.5095 25.8655 13.822 26.178Z",
    fill: "#99A4A3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseModalCreatePlan);
export default __webpack_public_path__ + "static/media/closeModalCreatePlan.08e4f80c924466e9d871fedb3578d9a8.svg";
export { ForwardRef as ReactComponent };